import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import Header from "../../Common/Header";

const PaymentSuccess = () => {
  return (
    <>
      <Toaster />
      <Header />
      <div className="bg-gray-50  flex items-center justify-center px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-black">
            {/* Left Section */}
            <div className="my-5">
              <div className="mb-8">
                <h2 className="text-2xl md:text-4xl font-bold py-2 underline">
                  Payment Success
                </h2>
                <p className="text-base md:text-lg font-semibold text-green-500">
                  Your payment has been successfully processed. Thank you for
                  your purchase! You can now access your purchased services or
                  products from your dashboard.
                </p>
              </div>
              <div className="flex items-center gap-4 mt-6">
                <Link to={"/dashboard"}>
                  <button className="border-2 w-full max-w-xs rounded-md bg-primary text-white border-[#240642] text-[#240642] px-6 py-3 font-bold text-lg md:text-xl">
                    Go to Dashboard
                  </button>
                </Link>
              </div>
            </div>
            {/* Right Section */}
            <div className="hidden md:flex justify-center items-center">
              <div className="relative w-full max-w-sm">
                <img
                  src="/assets/images/9.png"
                  alt="wills-guru-logo-white"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
